import { createFromIconfontCN } from '@ant-design/icons'

const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2006689_d7gpigd8ftu.js', // 在 iconfont.cn 上生成
})

export default MyIcon
